<mat-card-content>
  <div class="filter-wrapper flex">
    <button
      payee-icon-button
      [disabled]="loading"
      (click)="addMonth(-1)"
    >
      <mat-icon>arrow_left</mat-icon>
    </button>
    <payee-form-field>
      <span payee-label>{{ "CREDITS.TABLE.FILTERS.FROM" | translate }}</span>
      <payee-datepicker
        [formControl]="dateFrom"
        [max]="dateTo.value"
      ></payee-datepicker>
    </payee-form-field>
    <payee-form-field>
      <span payee-label>{{ "CREDITS.TABLE.FILTERS.TO" | translate }}</span>
      <payee-datepicker
        [formControl]="dateTo"
        [min]="dateFrom.value"
      ></payee-datepicker>
    </payee-form-field>
    <button
      payee-icon-button
      [disabled]="loading"
      (click)="addMonth(1)"
    >
      <mat-icon>arrow_right</mat-icon>
    </button>
    <button
      payee-icon-button
      [disabled]="loading"
      (click)="refresh.emit()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</mat-card-content>
